/* eslint-disable import/no-cycle */
/* SETTINGS */
export const CHANGE_LOCALE = 'CHANGE_LOCALE';

/* AUTH */
export const CHANGE_MOBILE = 'CHANGE_MOBILE';
export const CLEAN_MOBILE = 'CLEAN_MOBILE';
export const RESET_FORM_DATA = 'RESET_FORM_DATA';
export const LOGIN_USER = 'LOGIN_USER';
export const UPDATE_USER_AUTH = 'UPDATE_USER_AUTH';

export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGIN_USER_ERROR = 'LOGIN_USER_ERROR';
export const REGISTER_USER = 'REGISTER_USER';
export const REGISTER_USER_SUCCESS = 'REGISTER_USER_SUCCESS';
export const REGISTER_USER_ERROR = 'REGISTER_USER_ERROR';
export const LOGOUT_USER = 'LOGOUT_USER';
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_ERROR = 'FORGOT_PASSWORD_ERROR';
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_ERROR = 'RESET_PASSWORD_ERROR';
export const OTP_SEND_CODE = 'OTP_SEND_CODE';
export const OTP_SEND_CODE_SUCCESS = 'OTP_SEND_CODE_SUCCESS';
export const OTP_SEND_CODE_ERROR = 'OTP_SEND_CODE_ERROR';

/* MENU */
export const MENU_SET_CLASSNAMES = 'MENU_SET_CLASSNAMES';
export const MENU_CONTAINER_ADD_CLASSNAME = 'MENU_CONTAINER_ADD_CLASSNAME';
export const MENU_CLICK_MOBILE_MENU = 'MENU_CLICK_MOBILE_MENU';
export const MENU_CHANGE_DEFAULT_CLASSES = 'MENU_CHANGE_DEFAULT_CLASSES';
export const MENU_CHANGE_HAS_SUB_ITEM_STATUS =
  'MENU_CHANGE_HAS_SUB_ITEM_STATUS';

export const GET_BASE_SETTINGS = 'GET_BASE_SETTINGS';
export const BASE_SETTINGS = 'BASE_SETTINGS';
export const BASE_SETTING_ERROR = 'BASE_SETTING_ERROR';
export const BASE_SETTING_SUCCESS = 'BASE_SETTING_SUCCESS';
export const UPDATE_BASE_SETTING = 'UPDATE_BASE_SETTING';

export const GET_PROFILE = 'GET_PROFILE';
export const PROFILE = 'PROFILE';
export const PROFILE_ERROR = 'PROFILE_ERROR';
export const PROFILE_SUCCESS = 'PROFILE_SUCCESS';
export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const UPDATE_PROFILE_SECONDS = 'UPDATE_PROFILE_SECONDS';
export const UPDATE_PROFILE_EMAIL_MOBILE = 'UPDATE_PROFILE_EMAIL_MOBILE';
export const SEND_OTP_PROFILE_MOBILE = 'SEND_OTP_PROFILE_MOBILE';
export const SEND_OTP_PROFILE_EMAIL = 'SEND_OTP_PROFILE_EMAIL';

export const GET_MUKEBS = 'GET_MUKEBS';
export const MUKEBS = 'MUKEBS';
export const MUKEB_ERROR = 'MUKEB_ERROR';
export const MUKEB_SUCCESS = 'MUKEB_SUCCESS';
export const UPDATE_MUKEB = 'UPDATE_MUKEB';
export const CREATE_MUKEB = 'CREATE_MUKEB';
export const UPDATE_ACTION_STATUS_MUKEB = 'UPDATE_ACTION_STATUS_MUKEB';
export const OLD_MUKEBS = 'OLD_MUKEBS';
export const OLD_MUKEB_SUCCESS = 'OLD_MUKEB_SUCCESS';
export const OLD_MUKEB_ERROR = 'OLD_MUKEB_ERROR';
export const GET_OLD_MUKEB = 'GET_OLD_MUKEB';

export const GET_BENEFACTORS = 'GET_BENEFACTORS';
export const GET_MY_BENEFACTORS = 'GET_MY_BENEFACTORS';
export const BENEFACTORS = 'BENEFACTORS';
export const MY_BENEFACTORS = 'MY_BENEFACTORS';
export const BENEFACTOR_ERROR = 'BENEFACTOR_ERROR';
export const BENEFACTOR_SUCCESS = 'BENEFACTOR_SUCCESS';
// export const UPDATE_BENEFACTOR = 'UPDATE_BENEFACTOR';
export const CREATE_BENEFACTOR = 'CREATE_BENEFACTOR';

export const FEATURES = 'FEATURES';
export const GET_FEATURES = 'GET_FEATURES';
export const ADMIN_ITEMS = 'ADMIN_ITEMS';

export const USERS = 'USERS';
export const GET_USERS = 'GET_USERS';
export const DELETE_USER = 'DELETE_USER';
export const UPDATE_USER = 'UPDATE_USER';
export const CREATE_USER = 'CREATE_USER';
export const USER_SUCCESS = 'USER_SUCCESS';
export const USER_ERROR = 'USER_ERROR';

//POLLS
export const QUESTIONS = 'QUESTIONS';
export const GET_QUESTIONS = 'GET_QUESTIONS';

export const AREAS = 'AREAS';
export const GET_AREAS = 'GET_AREAS';

export const AXES = 'AXES';
export const GET_AXES = 'GET_AXES';
export const GET_AXES_SUCCESS = 'GET_AXES_SUCCESS';
export const GET_AXES_ERROR = 'GET_AXES_ERROR';
export const INSERT_NEW_AXE = 'INSERT_NEW_AXE';
export const INSERT_NEW_AXE_SUCCESS = 'INSERT_NEW_AXE_SUCCESS';
export const INSERT_NEW_AXE_ERROR = 'INSERT_NEW_AXE_ERROR';
export const DELETE_AXE = 'DELETE_AXE';
export const DELETE_AXE_SUCCESS = 'DELETE_AXE_SUCCESS';
export const DELETE_AXE_ERROR = 'DELETE_AXE_ERROR';
export const EDIT_AXE = 'EDIT_AXE';
export const EDIT_AXE_SUCCESS = 'EDIT_AXE_SUCCESS';
export const EDIT_AXE_ERROR = 'EDIT_AXE_ERROR';
export const GENERATE_PLATES = 'GENERATE_PLATES';
export const GENERATE_PLATES_SUCCESS = 'GENERATE_PLATES_SUCCESS';
export const GENERATE_PLATES_ERROR = 'GENERATE_PLATES_ERROR';

export const PLATES = 'PLATES';
export const GET_PLATES = 'GET_PLATES';
export const GET_PLATES_SUCCESS = 'GET_PLATES_SUCCESS';
export const GET_PLATES_ERROR = 'GET_PLATES_ERROR';
export const ASSIGN_PLATE_MUKEB = 'ASSIGN_PLATE_MUKEB';
export const ASSIGN_PLATE_MUKEB_SUCCESS = 'ASSIGN_PLATE_MUKEB_SUCCESS';
export const ASSIGN_PLATE_MUKEB_ERROR = 'ASSIGN_PLATE_MUKEB_ERROR';
export const CANCEL_PLATE = 'CANCEL_PLATE';
export const CANCEL_PLATE_SUCCESS = 'CANCEL_PLATE_SUCCESS';
export const CANCEL_PLATE_ERROR = 'CANCEL_PLATE_ERROR';
export const EXPORT_PLATES_EXCEL = 'EXPORT_PLATES_EXCEL';
export const EXPORT_PLATES_EXCEL_SUCCESS = 'EXPORT_PLATES_EXCEL_SUCCESS';
export const EXPORT_PLATES_EXCEL_ERROR = 'EXPORT_PLATES_EXCEL_ERROR';

export * from './plate/actions';
export * from './axe/actions';
export * from './menu/actions';
export * from './settings/actions';
export * from './auth/actions';
export * from './settings/base_setting/actions';
export * from './settings/profile/action';
